import { PlaceholderKind } from '@woundtech/ui-constants';
import parseISO from 'date-fns/parseISO';
import { format, utcToZonedTime } from 'date-fns-tz';
import { DateTime } from 'luxon';
import { DISPLAY_DATE_FORMAT } from './constants';
export const shortDate = (date: fhir.date | undefined, timeZone?: string) => {
  if (date) {
    try {
      if (timeZone) {
        return format(utcToZonedTime(date, timeZone), DISPLAY_DATE_FORMAT);
      }
      return format(parseISO(date), DISPLAY_DATE_FORMAT);
    } catch {
      return PlaceholderKind.NotAvailable;
    }
  }
  return PlaceholderKind.NotAvailable;
};

export const shortRescheduleDate = (date: fhir.date | undefined) => {
  if (date) {
    try {
      return DateTime.fromISO(date, { zone: 'utc' }).toFormat(
        DISPLAY_DATE_FORMAT
      );
    } catch {
      return PlaceholderKind.NotAvailable;
    }
  }
  return PlaceholderKind.NotAvailable;
};

export const dayOfWeekAbbr = (
  date: fhir.date | undefined,
  timeZone?: string
) => {
  if (date) {
    try {
      if (timeZone) {
        return format(utcToZonedTime(date, timeZone), 'ccc');
      }

      return DateTime.fromISO(date, { zone: 'utc' }).toFormat('ccc');
    } catch {
      return PlaceholderKind.NotAvailable;
    }
  }
  return PlaceholderKind.NotAvailable;
};

export const shortTimezoneDate = (date: Date | undefined) => {
  if (date) {
    try {
      return format(date, DISPLAY_DATE_FORMAT);
    } catch {
      return PlaceholderKind.NotAvailable;
    }
  }
  return PlaceholderKind.NotAvailable;
};

export const getDateFromPeriodDateTime = (datetime: string | undefined) => {
  if (datetime) {
    try {
      return datetime.substring(0, 10);
    } catch {
      return PlaceholderKind.NotAvailable;
    }
  }
  return PlaceholderKind.NotAvailable;
};
